/**
 * Copyright (c) 2018-present, Didi, Inc.
 * All rights reserved.
 *
 * @author Cory(kuanghongrui@didichuxing.com)
 *
 * @file The class of OMGH5CustomEvent
 */

import { IContext } from 'com/didichuxing/context/IContext';
import { IAttrs } from 'com/didichuxing/tracker/IAttrs';
import SequencedEvent from 'com/didichuxing/tracker/plugin/events/SequencedEvent';

export default class OMGH5CustomEvent extends SequencedEvent {

    /**
     * custom event id
     */
    private readonly eventId: string;

    /**
     * @constructor
     * @param {IAttrs} attrs
     * @param {IContext} context
     */
    constructor(eventId: string, attrs: IAttrs, context: IContext, info?: IAttrs) {
        super(attrs, context, info);
        this.eventId = eventId;
    }

    /**
     * @override
     * @inheritDoc
     * @returns {string}
     */
    public getType(): string {
        return this.eventId;
    }
}
